module.exports = __webpack_public_path__ + "img/PA.ffbdadba.png";